import { render } from "./review.vue?vue&type=template&id=01d7c65e&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"

import "./review.vue?vue&type=style&index=0&id=01d7c65e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d7c65e"]])

export default __exports__